module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/symbols/*"],"runtimeCaching":[{"urlPattern":{},"handler":"NetworkOnly"}]},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":2048,"quality":90,"linkImagesToOriginal":false,"backgroundColor":"transparent","disableBgImageOnAlpha":true,"withWebp":false,"showCaptions":false,"markdownCaptions":false,"wrapperStyle":"display: block; background: transparent !important;","ignore":["**/img/glyph_*.png","**/img/*_static.png","**/img/mystical-*.png"],"withAvif":false,"loading":"lazy","decoding":"async","disableBgImage":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-decap-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/opt/build/repo/src/cms/cms.js"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
